<div class="container">
    <div class="row" style="background-color: gainsboro;">
        <div class="col-10">
            <h3 class="titulo">¿Cómo funciona?</h3>
        </div>
        <div class="col-2">
            <button nbButton size="tiny" class="btn-close float-right" (click)="close()">
                <nb-icon nbPrefix icon="close-outline"></nb-icon>
              </button>
        </div>
    </div>
    <h4 class="altaybaja">Alta</h4>
    <hr>
    <p>Para dar de alta un operador arrastre un elemento de la lista izquierda hacia la derecha.</p>
    <h4 class="altaybaja">Baja</h4>
    <hr>
    <p>Para dar de baja un operador asignado arrastre un elemento de la lista derecha hacia la izquierda.</p>
</div>
